import React from "react";
import { AddOrderItemScreenActionsContext } from "./context";

export const useAddOrderItemScreenActionsProvider = () => {
  const context = React.useContext(AddOrderItemScreenActionsContext);
  return context;
};
